export default __webpack_public_path__ + "static/media/Total Systems Development.afa64291.png";